import { USER_DEVICE } from './types'

const INITIAL_STATE = {
  device: 'desktop',
}

const deviceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_DEVICE:
      return {
        ...state,
        device: action.payload,
      }
    default:
      return state
  }
}

export default deviceReducer
